module.exports = __webpack_public_path__ + "static/media/darwin_s copy.31df7a6f.png";